import { useMemo } from "react"
import { chain } from "lodash"
import { ERROR_CODES, MESSAGE_ROLES } from "../helpers/constants"
import { useAiTeammateContext } from "./context"
import useFetchMessages from "./fetch-messages"
import { useSendMessageContext } from "./context"

export function useIsOutOfSync() {
  const { error } = useAiTeammateContext()

  return useMemo(() => {
    return error?.code === ERROR_CODES.CHAT_CONTINUE_THREAD_WITH_MESSAGE_CONFLICT
  }, [error])
}

export function useShouldDisableUserInput() {
  const { isFetchingMessages } = useFetchMessages()
  const { isSendingMessage } = useSendMessageContext()
  const isOutOfSync = useIsOutOfSync()

  return useMemo(() => {
    return isFetchingMessages || isSendingMessage || isOutOfSync
  }, [isFetchingMessages, isSendingMessage, isOutOfSync])
}

export function useLastUserMessageText() {
  const { messages } = useAiTeammateContext()
  return useMemo(() => {
    if (messages && messages.length > 0 && messages.some(message => message.role === MESSAGE_ROLES.USER)) {
      return chain(messages).filter(message => message.role === MESSAGE_ROLES.USER).last().get("text").value()
    }
    return null
  }, [messages])
}

export function useLastAssistantMessageId() {
  const { messages } = useAiTeammateContext()
  return useMemo(() => {
    if (messages && messages.length > 0 && messages.some(message => message.role === MESSAGE_ROLES.ASSISTANT)) {
      return chain(messages).filter(message => message.role === MESSAGE_ROLES.ASSISTANT).last().get("id").value()
    }
    return null
  }, [messages])
}
